import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { DefaultHeaderService } from "./default-header.service";

@Injectable()
export class DefaultHeaderInterceptor implements HttpInterceptor {
    private readonly defaultHeaderService = inject(DefaultHeaderService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const defaultHeaders = this.defaultHeaderService.headers;
        let headers = request.headers;
        for(const [
            key,
            value
        ] of Object.entries(defaultHeaders)) {
            headers = headers.set(key,value);
        }

        const clone = request.clone({
            headers: headers
        });

        return next.handle(clone);
    }
}
